(function () {
  var controllerId = "mapController";
  angular
    .module("app")
    .controller(controllerId, ["$scope", "$rootScope", "$timeout", "mapService",
      function mapController($scope, $rootScope, $timeout, mapService) {
        $scope.mapId = "pcmMap";
        $scope.locationText = "";

        /////////////////////////////////////////////////////////////////
        // Event handlers section
        /////////////////////////////////////////////////////////////////
        $scope.$on("MapMove", function (event, message) { // jshint ignore:line
          mapService.getLocationString($scope.mapId)
            .then(function (locationText) {
              $scope.locationText = locationText;
            })
            .catch(function () {
              $scope.locationText = "Location unknown";
            });
        });
      }
    ]);
})();




// WEBPACK FOOTER //
// ./app/map/map.controller.js